namespace Matrix.Indexation {
    export interface BasketConstituentRow {
        BasketIndexCode?: string;
        ConstituentIndexCode?: string;
        Weight?: number;
        HedgeRatio?: number;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        BasketIndexName?: string;
        BasketIndexLocalCurrencyCode?: string;
        BasketIndexTypeCode?: string;
        ConstituentIndexName?: string;
        ConstituentIndexLocalCurrencyCode?: string;
        ConstituentIndexTypeCode?: string;
    }

    export namespace BasketConstituentRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'BasketIndexCode';
        export const localTextPrefix = 'Indexation.BasketConstituent';
        export const deletePermission = 'DataAdmin:BasketConstiuent';
        export const insertPermission = 'DataAdmin:BasketConstiuent';
        export const readPermission = 'Read:BasketConstiuent';
        export const updatePermission = 'DataAdmin:BasketConstiuent';

        export declare const enum Fields {
            BasketIndexCode = "BasketIndexCode",
            ConstituentIndexCode = "ConstituentIndexCode",
            Weight = "Weight",
            HedgeRatio = "HedgeRatio",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            BasketIndexName = "BasketIndexName",
            BasketIndexLocalCurrencyCode = "BasketIndexLocalCurrencyCode",
            BasketIndexTypeCode = "BasketIndexTypeCode",
            ConstituentIndexName = "ConstituentIndexName",
            ConstituentIndexLocalCurrencyCode = "ConstituentIndexLocalCurrencyCode",
            ConstituentIndexTypeCode = "ConstituentIndexTypeCode"
        }
    }
}
